export function checkExactRouteMatch(router: any, paths: string[]) {
  let routeMatched = false;
  paths.forEach((eachPath) => {
    if (router.asPath.includes(eachPath)) {
      routeMatched = true;
    }
  });
  return routeMatched;
}
